import React from "react";
import "./VerifyEmail.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../../assets/communityXlogo.svg";
import forgot from "../../../assets/verifyImage.svg";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const LoginHandler = () => {
    navigate("/");
  };
  return (
    <>
      <div className="verifyEmail">
        <div className="main">
          <Container>
            <Row className="justify-content-md-center py-3 mobile-main">
              <Col md="6" className="page-content-left text-center hide-mobile">
                <Image
                  loading="lazy"
                  src={forgot}
                  className="my-5 py-5 imgwidth-100"
                ></Image>
                <p>
                  Thank You for signing up for the CommunityX Digital business
                  listing
                </p>
              </Col>
              <Col md="6" className="page-content-right">
                <div className="text-center mb-2 mt-5">
                  <Image
                    loading="lazy"
                    src={Logo}
                    className="logo_Image"
                  ></Image>
                  <p className="sign-second mt-1 pt-1 pb-2 ">
                    You have successfully signed up!
                    <br />
                    Please Login.
                  </p>
                </div>
                <Row>
                  <div className="signemail pt-0 pb-3">
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3 "
                      onClick={LoginHandler}
                    >
                      Login
                    </Button>
                  </div>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
